export default __webpack_public_path__ + "static/media/Login.f3c05b83.jpg";